<script>
import draggable from 'vuedraggable';
import imgDragIcon from '@/components/countly/images/icons/drag-icon.svg';
import { AbstractListBox } from './commons';

export default AbstractListBox.extend({
  components: {
    draggable,
  },
  name: 'ClyChecklistbox',
  props: {
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    sortable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      imgDragIcon,
      sortMap: null,
    };
  },
  watch: {
    options: {
      immediate: true,
      handler(options) {
        if (this.sortable && !this.sortMap) {
          this.sortMap = Object.freeze(options.reduce((acc, opt, idx) => {
            acc[opt.value] = idx;
            return acc;
          }, {}));
        }
      },
    },
  },
  methods: {
    computeSortedOptions() {
      if (!this.sortable || !this.sortMap) {
        return this.options;
      }
      const { sortMap } = this;
      const wrapped = this.options.map((opt, idx) => ({ opt, idx, ord: sortMap[opt.value] || 0 }));

      wrapped.sort((a, b) => (a.ord - b.ord) || (a.idx - b.idx));

      return wrapped.map((item) => item.opt);
    },
    commitValue(val) {
      this.$emit('input', val);
      this.$emit('change', val);
    },
  },
  computed: {
    innerValue: {
      get() {
        return this.value;
      },
      set(newVal) {
        if (this.disabled) {
          return;
        }
        if (this.sortable && this.sortMap) {
          const { sortMap } = this;
          const wrapped = newVal.map((value, idx) => ({ value, idx, ord: sortMap[value] || 0 }));

          wrapped.sort((a, b) => (a.ord - b.ord) || (a.idx - b.idx));

          const sorted = wrapped.map((item) => item.value);
          this.commitValue(sorted);
        } else {
          this.commitValue(newVal);
        }
      },
    },
    sortedOptions: {
      get() {
        return this.computeSortedOptions();
      },
      set(sorted) {
        if (!this.sortable) {
          return;
        }
        this.sortMap = Object.freeze(sorted.reduce((acc, opt, idx) => {
          acc[opt.value] = idx;
          return acc;
        }, {}));
        this.innerValue = this.value; // triggers innerValue.set
        this.$emit('update:options', this.computeSortedOptions());
      },
    },
  },
});
</script>
<template>
  <div
    style="height: 100%"
    class="cly-vue-listbox"
    tabindex="0"
    :class="topClasses"
    @mouseenter="handleHover"
    @mouseleave="handleBlur"
    @focus="handleHover"
    @blur="handleBlur"
  >
    <vue-scroll
      v-if="options.length > 0"
      :style="vueScrollStyle"
      :ops="scrollCfg"
    >
      <div
        :style="wrapperStyle"
        class="cly-vue-listbox__items-wrapper"
      >
        <el-checkbox-group
          v-model="innerValue"
        >
          <draggable
            v-model="sortedOptions"
            handle=".drag-handler"
            :disabled="!sortable"
          >
            <div
              v-for="option in sortedOptions"
              :key="option.value"
              class="text-medium cly-vue-listbox__item"
            >
              <div
                v-if="sortable"
                class="drag-handler"
              >
                <img :src="imgDragIcon">
              </div>
              <el-checkbox
                :key="option.value"
                v-tooltip="option.label"
                :label="option.value"
              >
                {{ option.label }}
              </el-checkbox>
            </div>
          </draggable>
        </el-checkbox-group>
      </div>
    </vue-scroll>
    <div
      v-else
      class="cly-vue-listbox__no-data"
    >
      {{ noMatchFoundPlaceholder }}
    </div>
  </div>
</template>
